// prism/frontend/src/api/data.js
// Data management functions (clear, reset, etc.)

import { API_BASE, getAuthHeaders, invalidateCache } from './client.js';
import { logout } from './auth.js';

// Clear user events (NUCLEAR OPTION)
export async function clearUserEvents() {
  try {
    // Deletes all of the current user's recorded events (Postgres); the galaxy rebuilds without them
    invalidateCache('all');
    
    const res = await fetch(`${API_BASE}/api/protocols/clear-user-events`, {
      method: "DELETE",
      headers: getAuthHeaders(),
    });
    if (res.status === 401) {
      logout();
      throw new Error("Unauthorized - please login again");
    }
    if (!res.ok) throw new Error("Failed to clear user events");
    return res.json();
  } catch (error) {
    console.error(error);
    throw error;
  }
}
